import { createSlice } from '@reduxjs/toolkit';
import { getEmployees, unlinkEmployees } from './employeesActions';

const initialState = {
  isLoading: false,
  employees: [],
  error: null,
  success: false,
};

const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {},
  extraReducers: {
    // get employees
    [getEmployees.pending]: state => {
      state.isLoading = true;
    },
    [getEmployees.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.employees = payload.data;
    },
    [getEmployees.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // unlink employees
    [unlinkEmployees.pending]: state => {
      // state.isLoading = true;
    },
    [unlinkEmployees.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
    },
    [unlinkEmployees.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

export default employeesSlice.reducer;
